export default "__VITE_ASSET__BxBBVMgZ__"